/* ContactPartnerSection.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "._otyr1eps{margin-bottom:var(--ds-space-100)}";
const _4 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _3 = "._19pk1eps{margin-top:var(--ds-space-100)}";
const _2 = "._19bvxjmg{padding-left:var(--ds-space-200)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import { BodyNormal, LinkButton, LinkWithIcon } from '@atlassian/mpac-primitives';
import { LocalStorageUtils } from '@atlassian/mpac-utils';
import React, { useContext, useEffect, useState } from 'react';
import { CustomerPrivacySecurityContext } from '../../context/CustomerPrivacySecurityContext';
import { usePrivacyAndSecurityAnalytics } from '../../hooks';
import { ContactPartnerLink } from '../ContactPartnerLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._19pkxjmg{margin-top:var(--ds-space-200)}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxjmg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const ReadMoreContainer = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkxjmg", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ReadMoreContainer.displayName = 'ReadMoreContainer';
}
const SectionWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19bvxjmg _19pk1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionWrapper.displayName = 'SectionWrapper';
}
const SectionMessage = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1k3w _otyr1eps", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  SectionMessage.displayName = 'SectionMessage';
}
export const ContactPartnerSection = _ref5 => {
  let {
    isEmptyState,
    contactPartnerLinkProps
  } = _ref5;
  const {
    fireReadMoreLessEvent
  } = usePrivacyAndSecurityAnalytics();
  const {
    areAllSectionsExpanded
  } = useContext(CustomerPrivacySecurityContext);
  const [isExpanded, setIsExpanded] = useState(areAllSectionsExpanded);
  const hasUserVisitedBefore = !!LocalStorageUtils.getFromStorage('hasVisitedMarketplaceAppsPrivacyAndSecurity');
  useEffect(() => {
    if (!hasUserVisitedBefore) {
      setIsExpanded(true);
      LocalStorageUtils.writeStorage('hasVisitedMarketplaceAppsPrivacyAndSecurity', true);
    }
  }, []);
  useEffect(() => {
    if (hasUserVisitedBefore) {
      setIsExpanded(areAllSectionsExpanded);
    }
  }, [areAllSectionsExpanded]);
  const handleReadMoreLessClick = () => {
    setIsExpanded(prev => !prev);
    fireReadMoreLessEvent(!isExpanded);
  };
  const description = isEmptyState ? 'This partner is yet to fill in their privacy and security details.' : 'The Marketplace partner is solely responsible for the accuracy of the information provided below.';
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(BodyNormal, {
      children: [description, " For any further queries, ", /*#__PURE__*/_jsx(ContactPartnerLink, _objectSpread({}, contactPartnerLinkProps)), "."]
    }), isExpanded && /*#__PURE__*/_jsxs(SectionWrapper, {
      children: [/*#__PURE__*/_jsx(SectionMessage, {
        children: "These details pertain to the latest app version available on the Atlassian Marketplace. They are provided by the Marketplace partner, either during the app publishing process or while submitting the Privacy & Security questionnaire. Atlassian does not control the policies and procedures mentioned."
      }), /*#__PURE__*/_jsx(LinkWithIcon, {
        size: "medium",
        type: "external",
        href: "https://developer.atlassian.com/platform/marketplace/security-privacy-tab/",
        children: "How we collect this information"
      })]
    }), /*#__PURE__*/_jsx(ReadMoreContainer, {
      children: /*#__PURE__*/_jsx(LinkButton, {
        onClick: handleReadMoreLessClick,
        iconAfter: isExpanded ? /*#__PURE__*/_jsx(ChevronUpIcon, {
          label: "collapse-info-icon"
        }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
          label: "expand-info-icon"
        }),
        "aria-label": "".concat(isExpanded ? 'Read less' : 'Read more', " about how the information is collected"),
        "aria-expanded": isExpanded,
        children: isExpanded ? 'Read less' : 'Read more'
      })
    })]
  });
};